var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 28,
    height: 28,
    rx: 14,
    transform: "rotate(180 28 28)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8203_1157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7646 20.5032C16.7646 19.8891 16.2712 19.4067 15.6681 19.4067H9.53896L21.4793 7.46632C21.907 7.0387 21.907 6.34794 21.4793 5.92032C21.0517 5.4927 20.361 5.4927 19.9333 5.92032L7.99296 17.8607V11.7315C7.99296 11.1285 7.49955 10.6351 6.8965 10.6351C6.29345 10.6351 5.80005 11.1285 5.80005 11.7315V20.5032C5.80005 21.1062 6.29345 21.5996 6.8965 21.5996H15.6681C16.2712 21.5996 16.7646 21.1062 16.7646 20.5032Z",
    fill: "#11334E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8203_1157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 -1 25.5999 25.5996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownLeft);
export default __webpack_public_path__ + "static/media/arrow-down-left.751b9d3c3357d99fd0a0bf18096ddf08.svg";
export { ForwardRef as ReactComponent };